import { render, staticRenderFns } from "./Boxes.vue?vue&type=template&id=e7c1b9d8&scoped=true&"
import script from "./Boxes.vue?vue&type=script&lang=js&"
export * from "./Boxes.vue?vue&type=script&lang=js&"
import style0 from "./Boxes.vue?vue&type=style&index=0&id=e7c1b9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c1b9d8",
  null
  
)

component.options.__file = "Boxes.vue"
export default component.exports